import React, { useEffect, useState } from "react";
import "./verification.style.scss";
import { Card, Divider, Steps } from "antd";
import "antd/dist/antd.css";
import { get, responseValidator } from "../../../api";
import { toast } from "react-toastify";
import FirstLevel from "./first/first.index";
import SecondLevel from "./second/second.index";
import ThirdLevel from "./third/third.index";
import Loading from "../../../loading/loading.index";
import bronzePic from "./pic/bronze.png";
import silverPic from "./pic/silver.png";
import goldPic from "./pic/gold.png";

const { Step } = Steps;
export default function Verification() {
    const [state, setState] = useState();
    const [levelsDetail, setLevelsDetail] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [lastState, setLastState] = useState(0);
    useEffect(() => {
        get(`/User/Levels`).then(response => {
            setIsLoading(false);
            if (responseValidator(response.status)) {
                setLevelsDetail(response.data.data);
                if (
                    !response.data.data[1].isFinished &&
                    !response.data.data[2].isFinished
                )
                    setState(0);
                if (
                    response.data.data[1].isFinished &&
                    !response.data.data[2].isFinished
                ) {
                    setState(1);
                    setLastState(1);
                }

                if (response.data.data[2].isFinished) {
                    setState(2);
                    setLastState(2);
                }

                if (response.data.data[2].isFinished) {
                    setState(3);
                    setLastState(3);
                }
            } else toast.error(response.data.message);
        });
    }, []);
    if (isLoading) return <Loading />;
    if (levelsDetail.length !== 0)
        return (
            <div className="tmex-verification">
                <Card style={{ marginTop: "0" }}>
                    <Steps current={state} onChange={e => setState(e)}>
                        <Step icon={<Bronze />} title="سطح نقره ای" />
                        <Step icon={<Gold />} title="سطح طلایی" />
                    </Steps>
                </Card>
                <Divider />
                {state === 0 && <FirstLevel data={levelsDetail[1]} />}
                {state === 1 && <ThirdLevel data={levelsDetail[2]} />}
                {(state === 2 || state === 3) && (
                    <ThirdLevel data={levelsDetail[2]} />
                )}
                {/*state === 3 && <div className='finish-verification-page'>
          <Alert showIcon  type='success' message={`مراحل احراز هویت شما با موفقیت به پایان رسیده است`} banner={false} />
        </div> */}
            </div>
        );
    else return null;
}

export function Complete(props) {
    return (
        <div className="complete-status">
            <h4>{props.title}</h4>
            <span />
            <p>تکمیل شده</p>
        </div>
    );
}

export function Pending(props) {
    return (
        <div className="pending-status">
            <h4>{props.title}</h4>
            <span />
            <p>در انتظار {props.req}</p>
        </div>
    );
}

export function Error(props) {
    return (
        <div className="error-status">
            <h4>{props.title}</h4>
            <span />
            <p>رد شده</p>
        </div>
    );
}

export function Bronze(props) {
    return <img style={{ width: "26px", height: "26px" }} src={bronzePic} />;
}

export function Silver(props) {
    return <img style={{ width: "26px", height: "26px" }} src={silverPic} />;
}

export function Gold(props) {
    return <img style={{ width: "26px", height: "26px" }} src={goldPic} />;
}
